export const BASE_URL: string | undefined = process.env.REACT_APP_API_ADDRESS;
export const API_URL: string = `${BASE_URL}/api`;
export const LOGO: string = require("../Assets/logo.svg").default;
